import { render, staticRenderFns } from "./NewRirekishoAiMyprCard.vue?vue&type=template&id=40e3e5cd&scoped=true"
import script from "./NewRirekishoAiMyprCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewRirekishoAiMyprCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewRirekishoAiMyprCard.vue?vue&type=style&index=0&id=40e3e5cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e3e5cd",
  null
  
)

export default component.exports